import { createFileRoute } from '@tanstack/react-router';
import BusinessProcessPage from '../../components/analysis/BusinessProcessPage';

export const Route = createFileRoute('/analysis/process')({
  component: BusinessProcessPage,
});
